import type { ConfigTags, TagRow } from '../../../types'

// Inverse of collectTags: seed the editor's rows from an existing tags bag when
// editing a config that already has tags.
export function buildRowsFromTags(tags: ConfigTags): TagRow[] {
  return Object.entries(tags).map(([key, value]) => ({ key, value }))
}
